module.exports = import("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/js/all.min.js");;